import styled from 'styled-components';

import React from 'react'

const conf = {
  width: {
    md: '74px',
    sm: '45px',
  },
  spanSize: {
    md: '18px',
    sm: '15px',
  },
  titleSize: {
    md: '32px',
    sm: '24px',
  },
  titleLH: {
    md: '40px',
    sm: '24px',
  }
}

const UIStyle = styled.div`
  height: ${({size})=>{return conf.width[size]}};
  display: flex;
  >img {
    height: ${({size})=>{return conf.width[size]}};
    width: ${({size})=>{return conf.width[size]}};
    margin-right: 10px;
    border-radius: 50%;
    background-color: #ccc;
  }
  .tit-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    >span {
      font-size: ${({size})=>{return conf.spanSize[size]}};
      color: #999999;
    }
    .user-tit {
      font-size: ${({size})=>{return conf.titleSize[size]}};
      color: #333;
      line-height: ${({size})=>{return conf.titleLH[size]}};
    }
  }
`;

export default function UserInfoItem(props) {
  return (
    <UIStyle size={props.size || 'md'}>
      <img src={props.img} alt=""/>
      <div className="tit-info">
        <span>Created and owned by</span>
        <div className="user-tit">{props.children}</div>
      </div>
    </UIStyle>
  )
}
